import { render, staticRenderFns } from "./WechatQrcode.vue?vue&type=template&id=c1ca3554&scoped=true"
import script from "./WechatQrcode.vue?vue&type=script&lang=js"
export * from "./WechatQrcode.vue?vue&type=script&lang=js"
import style0 from "./WechatQrcode.vue?vue&type=style&index=0&id=c1ca3554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ca3554",
  null
  
)

export default component.exports